export default "__VITE_ASSET__CI4Kslol__"